// Generated by scripts/build-ui-icons.mjs.
import { createAppIcon } from "./base";
import { UserCircleIcon as UserCircleGlyph } from "@phosphor-icons/react/dist/ssr/UserCircle";
import { UserFocusIcon as UserFocusGlyph } from "@phosphor-icons/react/dist/ssr/UserFocus";
import { UserMinusIcon as UserMinusGlyph } from "@phosphor-icons/react/dist/ssr/UserMinus";
import { UserPlusIcon as UserPlusGlyph } from "@phosphor-icons/react/dist/ssr/UserPlus";
import { UsersIcon as UsersGlyph } from "@phosphor-icons/react/dist/ssr/Users";
import { UsersThreeIcon as UsersThreeGlyph } from "@phosphor-icons/react/dist/ssr/UsersThree";
import { VideoCameraIcon as VideoCameraGlyph } from "@phosphor-icons/react/dist/ssr/VideoCamera";
import { WalletIcon as WalletGlyph } from "@phosphor-icons/react/dist/ssr/Wallet";
import { WarningIcon as WarningGlyph } from "@phosphor-icons/react/dist/ssr/Warning";
import { WarningCircleIcon as WarningCircleGlyph } from "@phosphor-icons/react/dist/ssr/WarningCircle";
import { WrenchIcon as WrenchGlyph } from "@phosphor-icons/react/dist/ssr/Wrench";
import { XIcon as XGlyph } from "@phosphor-icons/react/dist/ssr/X";
import { XCircleIcon as XCircleGlyph } from "@phosphor-icons/react/dist/ssr/XCircle";

export const UserCircle = /* @__PURE__ */ createAppIcon(
  UserCircleGlyph,
  "UserCircle",
);
export const UserFocus = /* @__PURE__ */ createAppIcon(
  UserFocusGlyph,
  "UserFocus",
);
export const UserMinus = /* @__PURE__ */ createAppIcon(
  UserMinusGlyph,
  "UserMinus",
);
export const UserPlus = /* @__PURE__ */ createAppIcon(
  UserPlusGlyph,
  "UserPlus",
);
export const Users = /* @__PURE__ */ createAppIcon(UsersGlyph, "Users");
export const UsersThree = /* @__PURE__ */ createAppIcon(
  UsersThreeGlyph,
  "UsersThree",
);
export const VideoCamera = /* @__PURE__ */ createAppIcon(
  VideoCameraGlyph,
  "VideoCamera",
);
export const Wallet = /* @__PURE__ */ createAppIcon(WalletGlyph, "Wallet");
export const Warning = /* @__PURE__ */ createAppIcon(WarningGlyph, "Warning");
export const WarningCircle = /* @__PURE__ */ createAppIcon(
  WarningCircleGlyph,
  "WarningCircle",
);
export const Wrench = /* @__PURE__ */ createAppIcon(WrenchGlyph, "Wrench");
export const X = /* @__PURE__ */ createAppIcon(XGlyph, "X");
export const XCircle = /* @__PURE__ */ createAppIcon(XCircleGlyph, "XCircle");
